module.exports = __webpack_public_path__ + "static/media/course-default.3deb5cf9.svg";